import { useLocation, useSearchParams } from 'react-router-dom';
import { useCallback, useMemo } from 'react';
import queryString from 'query-string';

export const useQueryString = () => {
  //eslint-disable-next-line
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  const parsedQueryString = useMemo(
    () => queryString.parse(location.search, { arrayFormat: 'comma' }),
    [location.search]
  );

  const updateQueryString = useCallback(
    (
      obj: Record<
        string,
        string | number | string[] | number[] | undefined | null
      >,
      replace = false
    ) => {
      setSearchParams(
        queryString.stringify(
          { ...parsedQueryString, ...obj },
          { arrayFormat: 'comma' }
        ),
        { replace }
      );
    },
    [parsedQueryString, setSearchParams]
  );

  const resetQueryString = useCallback(() => {
    setSearchParams({});
  }, [setSearchParams]);

  const isQueryStringApplied = useCallback(
    (param: string) => {
      const foundValue = searchParams.get(param);
      return foundValue && foundValue.length > 0;
    },
    [searchParams]
  );

  const getQueryStringArray = useCallback(
    (param: string) => {
      if (isQueryStringApplied(param)) {
        return searchParams.get(param)?.split(',') || [];
      } else {
        return [];
      }
    },
    [isQueryStringApplied, searchParams]
  );

  return {
    updateQueryString,
    resetQueryString,
    parsedQueryString,
    isQueryStringApplied,
    getQueryStringArray,
  };
};
